import { render, staticRenderFns } from "./LegalTerms.vue?vue&type=template&id=0bfe8d18&scoped=true"
import script from "./LegalTerms.vue?vue&type=script&lang=js"
export * from "./LegalTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe8d18",
  null
  
)

export default component.exports